/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetLeveragedTokenTypeQueryVariables = Types.Exact<{
	input: Types.LeveragedTokenTypeInput;
}>;

export type GetLeveragedTokenTypeQuery = { __typename?: "Query"; leveragedTokenType: Types.LeveragedTokenType };

export const GetLeveragedTokenTypeDocument = gql`
	query getLeveragedTokenType($input: LeveragedTokenTypeInput!) {
		leveragedTokenType(input: $input)
	}
`;

@Injectable({
	providedIn: "root"
})
export class GetLeveragedTokenTypeGQLService extends Apollo.Query<
	GetLeveragedTokenTypeQuery,
	GetLeveragedTokenTypeQueryVariables
> {
	document = GetLeveragedTokenTypeDocument;
	client = "staking";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
